import React from 'react';

import { StyledSkeletonFile } from './styles';

import Skeleton from 'react-loading-skeleton';

export default function SkeletonFile({ count = 1, hideButtonLoadMoreFiles }) {
  return (
    <>
      {[...new Array(count)].map((_, index) => (
        <StyledSkeletonFile key={'skeleton-file-body-' + index}>
          <div className='skeleton-file-body'>
            <div className='container-skeleton'>
              <Skeleton
                containerClassName='flex-1'
                className='icon-file-skeleton'
                circle
                width={48}
                height={48}
              />

              <Skeleton
                containerClassName='flex-1'
                className='name-file-skeleton'
              />
            </div>
            <div className='container-skeleton skeleton-file-actions'>
              <Skeleton
                containerClassName='flex-1'
                className='info-file-skeleton'
              />
              <Skeleton
                containerClassName='flex-1'
                className='action-file-skeleton'
              />
            </div>
          </div>
        </StyledSkeletonFile>
      ))}
      {!hideButtonLoadMoreFiles && (
        <Skeleton
          containerClassName='flex-1'
          height={33}
          width={179}
          style={{ marginTop: 48 }}
        />
      )}
    </>
  );
}
